import React from 'react';

const features = [
{
  id: 'veikart',
  num: '01',
  title: 'INTERAKTIVT VEIKART',
  subtitle: 'Sanntids norsk kartdata',
  desc: 'NordPass sitt interaktive veikart gir deg den mest oppdaterte informasjonen om norske veier, trafikk og veiforhold. Integrert med Statens vegvesen og Meteorologisk institutt for presis sanntidsdata.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1a6c0fc81-1772191887953.png",
  alt: 'Aerial view of Norwegian road network with GPS tracking overlay showing real-time traffic conditions',
  benefits: [
  'Sanntids trafikkinformasjon',
  'Veiarbeid og stengte veier',
  'Vær- og føreforhold',
  'Automatisk ruting rundt hindringer',
  'Offline kart for fjelloverganger'],

  color: '#3B6FD4',
  flip: false
},
{
  id: 'bomkalkulator',
  num: '02',
  title: 'BOMKALKULATOR',
  subtitle: 'Nøyaktig prisberegning',
  desc: 'Beregn eksakte bomkostnader for enhver rute i Norge. Vår kalkulator tar hensyn til kjøretøytype, AutoPASS-rabatter, tidspunkt og alle aktive bomstasjoner langs ruten.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_12311da59-1772191891423.png",
  alt: 'Norwegian toll station on highway with AutoPASS lane and electronic payment system at sunset',
  benefits: [
  'Alle norske bomstasjoner',
  'AutoPASS-rabatter beregnet automatisk',
  'Elbil-rabatter inkludert',
  'Historisk prisdata',
  'Eksport til regnskapsystem'],

  color: '#E8A838',
  flip: true
},
{
  id: 'kjoretoy',
  num: '03',
  title: 'KJØRETØYADMINISTRASJON',
  subtitle: 'Full kontroll over flåten din',
  desc: 'Administrer alle dine kjøretøy fra ett sted. Registrer biler, lastebiler og elbiler med spesifikke profiler for nøyaktig bomberegning og personalisert navigasjon.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_18103c45a-1772191888751.png",
  alt: 'Fleet of Norwegian commercial vehicles parked in depot with mountains in background at dawn',
  benefits: [
  'Ubegrenset kjøretøyregistrering',
  'Automatisk kjøretøygjenkjenning',
  'Elbil-spesifikke ruter',
  'Vedlikeholdslogg',
  'Deling med sjåfører'],

  color: '#4CAF50',
  flip: false
}];


const ServiceFeatures = () => {
  return (
    <section style={{ background: '#050A12', padding: '80px 0' }}>
      {features?.map((feature, i) =>
      <div
        key={i}
        id={feature?.id}
        style={{
          padding: '80px 5%',
          borderBottom: '1px solid rgba(255,255,255,0.04)',
          background: i % 2 === 1 ? 'rgba(255,255,255,0.01)' : 'transparent'
        }}>
        
          <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
          alignItems: 'center',
          direction: feature?.flip ? 'rtl' : 'ltr'
        }}>
            {/* Image */}
            <div style={{ direction: 'ltr', position: 'relative' }}>
              <div style={{ position: 'relative', overflow: 'hidden' }}>
                <img
                src={feature?.img}
                alt={feature?.alt}
                style={{
                  width: '100%',
                  height: '480px',
                  objectFit: 'cover',
                  filter: 'brightness(0.75) contrast(1.1)',
                  display: 'block'
                }} />
              
                {/* Number overlay */}
                <div style={{
                position: 'absolute',
                bottom: '-20px',
                right: '-20px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '8rem',
                fontWeight: 800,
                color: `${feature?.color}20`,
                lineHeight: 1,
                pointerEvents: 'none'
              }}>{feature?.num}</div>
              </div>
            </div>

            {/* Content */}
            <div style={{ direction: 'ltr' }}>
              <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: feature?.color,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '12px'
            }}>{feature?.num} — {feature?.subtitle}</div>

              <h2 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.75rem, 3vw, 2.75rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.04em',
              lineHeight: 1,
              marginBottom: '24px'
            }}>{feature?.title}</h2>

              <p style={{
              fontFamily: 'Lora, serif',
              fontSize: '1.0625rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8,
              marginBottom: '36px'
            }}>{feature?.desc}</p>

              {/* Benefits */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '36px' }}>
                {feature?.benefits?.map((b, j) =>
              <div key={j} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                  width: '20px', height: '20px',
                  background: `${feature?.color}20`,
                  border: `1px solid ${feature?.color}40`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0
                }}>
                      <div style={{ width: '6px', height: '6px', background: feature?.color }} />
                    </div>
                    <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.9375rem', color: 'rgba(238,240,242,0.75)' }}>{b}</span>
                  </div>
              )}
              </div>

              <a
              href="/login"
              style={{
                display: 'inline-block',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: '#EEF0F2',
                textDecoration: 'none',
                padding: '12px 24px',
                background: feature?.color,
                letterSpacing: '0.08em',
                textTransform: 'uppercase'
              }}>
              PRØV GRATIS →</a>
            </div>
          </div>
        </div>
      )}
    </section>);

};

export default ServiceFeatures;